export default "__VITE_ASSET__BRIvXXTU__"